import { Observable } from "rxjs";

import { get, post} from "@utils/axios";
import sessionService from "./session.service";


class UserManagementService {

    getUsersData(): Observable<any> { 
        return post(`${sessionService.getClient()?.appServiceUrl}/users/getUsersData`);
    }

    changeUserStatus(data : any): Observable<any> { 
        return post(`${sessionService.getClient()?.appServiceUrl}/users/change-user-status` , {
            status : data.operation,
            user_first_name : data.user_first_name,
            user_last_name : data.user_last_name, 
            user_email : data.user_email
        });
    }

    getColumnsList() : Observable<any> {
        return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=User Mgmt`);
    }

    getDropdownData(data : any) : Observable<any> {
        return post(`${sessionService.getClient()?.appServiceUrl}/users/getDropDownData` , data);
    }

    createUser(data : any) :  Observable<any> {  
        data = {...data , secondary_office_name : data.office_name === 'ALL' && !['ReportUser','ReportUserAdmin'].includes(data.user_role) ? undefined : data.secondary_office_name}  
        return post(`${sessionService.getClient()?.appServiceUrl}/users/createUser` , data);
    }

    editUser(data : any) : any {
        data = {...data , secondary_office_name : data.office_name === 'ALL' && !['ReportUser','ReportUserAdmin'].includes(data.user_role) ? undefined : data.secondary_office_name} 
        return post(`${sessionService.getClient()?.appServiceUrl}/users/editUser` , data);
    }

    getAssignmentStatus() : any {
        return get(`${sessionService.getClient()?.appServiceUrl}/users/assignment-status`);
    }

    getPatientAssignment() : any {
        return get(`${sessionService.getClient()?.appServiceUrl}/users/patient-assignment`);
    }

}

export default new UserManagementService();
